import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/ModalActions';
import '../../stylesheets/registry/_aboutZola.less';
import importImages from '../../util/webpack';

const modalImages = importImages(require.context('../../../public/images/registry/aboutZolaBrands/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

/**
 * About Zola Modal - v2
 * Modal about Zola that appears on the public registry
 *
 * v2 changes:
 * updated copy and brand images
 * started: 09 04 18
 */
const AboutZolaModal = (props) => {
  const { closeModal } = props;

  return (
    <div id="about-zola-modal">
      <div className="modal-header about-top">
        <div className="logo zola-registry-logo-black-100">Zola</div>
        <div className="row">
          <div className="col-sm-9 col-xs-12">
            <h1>What&apos;s Zola?</h1>
            <p>
              Zola is everything you and your family love about your favorite department store and so much more. As the wedding registry experts, we carry 50,000 gifts, experiences, and cash funds, plus 500 top brands. From registry staples like KitchenAid and Le Creuset to up-and-comers like Sonos and Airbnb, we have it all. Wedding planning is stressful enough—we make the entire process easier for couples and their guests.
            </p>
            <p>
              Questions? We&apos;re always happy to help. Reach out to us at <a href="mailto:support@zola.com">support@zola.com</a> or 1 (408) 657-ZOLA (9652).
            </p>
          </div>
        </div>
      </div>
      <div className="about-quotes">
        <h1>Guests<span className="text-lowercase script">  love </span>Zola</h1>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="quote">
              <p>
                &ldquo;I was so excited to get my nephew a gorgeous cast iron skillet, I didn&apos;t even realize that shipping was free. Icing on the cake!&rdquo;
              </p>
              <small className="text-uppercase">Randi K</small>
            </div>
            <div className="quote">
              <p>
                &ldquo;When our friends&apos; mixer was on sale at another store, Zola price matched it right away. Better for our wallets (and our gift-giving cred).&rdquo;
              </p>
              <small className="text-uppercase">James C.</small>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className="quote">
              <p>
                &ldquo;I couldn&apos;t believe how fast Zola&apos;s Registry Advisors answered the questions I had, and they did it with such kindness. A+ for customer service.&rdquo;
              </p>
              <small className="text-uppercase">Maria R.</small>
            </div>
            <div className="quote">
              <p>
                &rdquo;Shopping with Zola was quick, no fuss, no bother. I am 84 years old and it was so easy to buy my granddaughter and her new husband a gift.&rdquo;
              </p>
              <small className="text-uppercase">Doris W.</small>
            </div>
          </div>
        </div>
      </div>
      <div className="press">
        <div className="row text-center seen-in">
          <small className="text-uppercase">We Carry Everything</small><br /><br />
        </div>
        <div className="row">
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('calphalon')} className="center-block" width="223" alt="Calphalon" />
          </div>
          <div className="col-sm-4 col-xs-12 logo xl">
            <img src={modalImages('lecreuset')} className="center-block" width="203" alt="Le Creuset" />
          </div>
          <div className="col-sm-4 col-xs-12 logo cuisinart">
            <img src={modalImages('cuisinart')} className="center-block" width="178" alt="Cuisinart" />
          </div>
          <div className="col-sm-4 col-xs-12 logo xl">
            <img src={modalImages('oxo')} className="center-block" width="88" alt="OXO" />
          </div>
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('kitchenaid')} className="center-block" width="288" alt="Kitchen Aid" />
          </div>
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('libbey')} className="center-block" width="124" alt="Libbey" />
          </div>
        </div>
      </div>
      <div className="row text-center cta">
        <a role="button" className="btn btn-primary btn-wide" onClick={closeModal}>return to previous page</a>
      </div>
    </div>
  );
};


AboutZolaModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal())
});

export default connect(
  null,
  mapDispatchToProps
)(AboutZolaModal);



/** WEBPACK FOOTER **
 ** ./src/components/registry/AboutZolaModalV2.jsx
 **/